import { Component, NgModule , OnDestroy, OnInit,  EventEmitter, Input, Output, ViewContainerRef,
  OnChanges, TemplateRef, ViewChild} from '@angular/core';
import {DemoService} from '../../../demo.service';
import { HotToastService } from '@ngneat/hot-toast';
import {Routes, RouterModule, Router} from '@angular/router';
import { MysqlService } from './../../../services/mysql.service';

import { Job } from '../../../shared/models/job.model';
import { DatePipe } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpRequest, HttpResponse, HttpEvent } from '@angular/common/http';

// import { Observable } from 'rxjs/Observable'; // this created errors ats use below
import {BehaviorSubject, Observable, Subject, map, Subscription} from 'rxjs';
import { FileUploaderService } from './../../../services/file-uploader-service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalFunctionsService } from './../../../services/global-functions.service';
import { JobPlaintiff } from './../../../shared/models/jobPlaintiff.model';
import { JobReportSubject } from './../../../shared/models/jobReportSubject.model';


import { ViewEncapsulation } from '@angular/core';
import { FieldSettingsModel, DragEventArgs } from '@syncfusion/ej2-dropdowns';
import { DataManager } from '@syncfusion/ej2-data';
import { ListBoxComponent } from '@syncfusion/ej2-angular-dropdowns';


@Component({
  selector: 'app-job-report-subject-add-widget',
  templateUrl: './job-report-subject-add-widget.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./job-report-subject-add-widget.component.css']
})
export class JobReportSubjectAddWidgetComponent implements OnInit, OnChanges {
  // setup as observable?
  // @Input() item_id?: Observable<any[]>; // impliments on changes.
  @Input() item_id?: any; // impliments on changes.
  @Input() item_data?: Observable<any[]>; // if data.model is sent : Observable<any[]>;
  @Input() use_item_data? = 'no'; // if data.model is sent use this instead of item_id
  @Input() item_user_level_id? = '5'; // default to agent just in case
  @Input() item_brand_type_id? = '';
  @Input() show_buttons? = 'no'; // yes | no
  @Input() widget_title? = '';
  @Input() widget_size? = 'side'; // side | abstract | full

  job: Object;
  @Input() job_id?;

  @Input() intialCount = 221;
  @Input() count = this.intialCount;
  @Output('closeParentModel') closeParentModel: EventEmitter<any> = new EventEmitter();

  @Input() subject_id?: number; // side | abstract | full

  // model: JobReportSubject;
  model: any;
job_plaintiff_types: Object;
  job_report_subjects: any;
  job_subjects: any;

  // setup lists
  // subjectList : JobReportSubject;
  // subjectReportList : JobReportSubject;
  subjectList : any;
  subjectReportList : any;


  @ViewChild('listbox1') public listObj1: ListBoxComponent; @ViewChild('listbox2') public listObj2: ListBoxComponent;
  public dataA: DataManager = new DataManager({
    
    // json: [
    //     { Name: 'Australia', Code: 'AU' },
    //     { Name: 'Bermuda', Code: 'BM' },
    //     { Name: 'Canada', Code: 'CA' },
    //     { Name: 'Cameroon', Code: 'CM' },
    //     { Name: 'Denmark', Code: 'DK' },
    //     { Name: 'France', Code: 'FR' },
    //     { Name: 'Finland', Code: 'FI' },
    //     { Name: 'Germany', Code: 'DE' },
    //     { Name: 'Hong Kong', Code: 'HK' }
    // ]
});
public fields: FieldSettingsModel = { text: 'Name' };
public dataB: DataManager = new DataManager({
    // json: [
    //     { Name: 'India', Code: 'IN' },
    //     { Name: 'Italy', Code: 'IT' },
    //     { Name: 'Japan', Code: 'JP' },
    //     { Name: 'Mexico', Code: 'MX' },
    //     { Name: 'Norway', Code: 'NO' },
    //     { Name: 'Poland', Code: 'PL' },
    //     { Name: 'Switzerland', Code: 'CH' },
    //     { Name: 'United Kingdom', Code: 'GB' },
    //     { Name: 'United States', Code: 'US' }
    // ]
});
public modifiedDataA: ModifiedRecords = { addedRecords: [], deletedRecords: [], changedRecords: [] };
public modifiedDataB: ModifiedRecords = { addedRecords: [], deletedRecords: [], changedRecords: [] };
public saveChanges(): void {
    this.dataA.saveChanges(this.modifiedDataA, this.fields.text);
    this.dataB.saveChanges(this.modifiedDataB, this.fields.text);
    this.modifiedDataA.addedRecords = []; this.modifiedDataB.addedRecords = [];
  
    console.log('DataB: ' + JSON.stringify(this.dataB.dataSource.json));
  //  console.log('Modifided Data: ' + JSON.stringify(this.modifiedDataB));
 // console.log(JSON.stringify(this.dataB.dataSource.json));
 // try to count length
 // run the delete with job id first
 // run the loop through update script
let jsonResult = this.dataB.dataSource.json;
// const countResult = jsonResult.length; // cannot find lenght error.
let countResult = Object.keys(jsonResult).length;
console.log('countResult: ' + countResult);

// :: updates a single record, need to put in to a loop.
//  this.updateJobReportSubjects(this.dataB.dataSource.json[0]);


}
public onDropGroupA(args: DragEventArgs): void {
    args.items.forEach((item: { [key: string]: Object; }): void => {
        /*Preventing item manipulation while doing drag and drop within same list box.*/
        if (!this.listObj1.getDataByValue(item[this.fields.text] as string)) {
            this.modifiedDataB.addedRecords.push(item);
            this.modifiedDataA.deletedRecords.push(item);
        }
    });
}
public onDropGroupB(args: DragEventArgs): void {
    args.items.forEach((item: { [key: string]: Object; }): void => {
        if (!this.listObj2.getDataByValue(item[this.fields.text] as string)) {
            this.modifiedDataA.addedRecords.push(item);
            this.modifiedDataB.deletedRecords.push(item);
        }
    });
}
public subjectFields = { text: "subject_number", value: 'subject_id'};




// :: Ngx- Bootstrap Sortable
itemObjectsLeft: any[] = [
  { id: 1, name: 'Windstorm' },
  { id: 2, name: 'Bombasto' },
  { id: 3, name: 'Magneta' }
];

itemObjectsRight: any[] = [
  { id: 4, name: 'Tornado' },
  { id: 5, name: 'Mr. O' },
  { id: 6, name: 'Tomato' }
];





constructor(
  private http: HttpClient, private _demoService: DemoService,
  private route: ActivatedRoute, public toastr: HotToastService,
   vcr: ViewContainerRef, private router: Router,
   public HttpClient:HttpClient,
   private fileUploader: FileUploaderService,
   private _mysqlService: MysqlService,
   private modalService: BsModalService,
   public datepipe: DatePipe,
   public gfunc: GlobalFunctionsService
) { }

// check for changes. to load data.
ngOnChanges(changes) {


// :: Test Setup Multo list with drag and drop between
this.job_id = this.item_id;
this.getJobReportSubjects(this.job_id);
this.getJobSubjects(this.job_id);

   // Removes from GroupA - Subjects List
// :: https://www.angularjswiki.com/angular/how-to-remove-an-element-from-array-in-angular-or-typescript/
// this.subjectReportList.forEach( (element) => {
// //   element.product_desc = element.product_desc.substring(0,10);
// this.removeListItem(element.subject_id);
// });


// Set the actual data list from database on load.
// this.dataB = new DataManager({
//   json: [this.job_report_subjects]
// });


 // this.model = new JobPlaintiff();
 // this.getJobPlaintiffTypes();
  if (changes.item_id) {
    // deal with asynchronous Observable result
    this.job_id = changes.item_id.currentValue;
 //   this.model.job_id = this.job_id;
    // this.getJob(this.job_id);

  }
}


ngOnInit() {
}

removeListItem(subject_id){
  this.subjectList = this.subjectList.filter(item => item.subject_id !== subject_id);
}


// Functions
getJob(job_id) {
this._demoService.getJobID(job_id).subscribe(
   data => { this.job = data;
    let res = data[0];
    // Run the job data queries.
  },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}

// :: model sends multiple items. // Need to remove from database first then add.
addJobPlaintiff(model) {
this._demoService.addJobPlaintiff(model).subscribe(
  data => { },
  err => console.error(err),
  // () => console.log('done loading Trace Types')
);
this.toastr.info('Job Reports Subject list Updated');
this.closeParentModel.emit();
}

// many at once.
updateJobReportSubjects(model, job_id) {
  console.log('model:' + JSON.stringify(model)  );
// :: NEED TO ADD A LOOP TO THIS SUBSCRIPTION BELOW
let countResult = Object.keys(model).length;
// console.log(countResult);
// delete all records of job before insert
  this.deleteJobReportSubjects(job_id);
var i;
for (let i = 0; i < countResult; i++) {
  this._demoService.updateJobReportSubjects(model[i], job_id).subscribe(
    data => { 
      console.log('inserted: ' + i);
    },
    err => console.error(err),
    // () => console.log('done loading Trace Types')
  );
}// end loop
 // this.toastr.info('job report subject(s) added');
this.closeParentModel.emit();
  }


getJobPlaintiffTypes() {
this._demoService.getJobPlaintiffTypes().subscribe(
   data => { this.job_plaintiff_types = data; },
   err => console.error(err),
   // () => console.log('done loading Trace Types')
 );
}



getJobReportSubjects(job_id) {
  this._demoService.getJobReportSubjects(job_id).subscribe(
     data => { this.job_report_subjects = data;
      // this.dataB = new DataManager({
      //     json: [data]
      //   });
      // map the results.
      this.subjectReportList = this.job_report_subjects.map(s => ({
        subject_id: s.subject_id,
        subject_number: s.subject_number
         }));
      // set the existing data in editor !!! Wrong format.
        // this.dataB = new DataManager({
        //   json: [this.subjectReportList]
        //  });
     // console.log(this.subjectReportList);


                 


    },
     err => console.error(err),
     // () => console.log('done loading Trace Types')
   );
  }



  deleteJobReportSubjects(job_id) {
      this._demoService.deleteJobReportSubjects(job_id).subscribe(
         data => {
       // reset the plaintiff list.
           return true;
         },
         error => {
           console.error('Error deleting !');
          return console.log(error);
         }
      );

  }


  getJobSubjects(job_id){
    this._demoService.getJobSubjectsNotInReportList(job_id).subscribe(
      data => { this.job_subjects = data;
      
            // map the results.
            this.subjectList = this.job_subjects.map(s => ({
              subject_id: s.subject_id,
              subject_number: s.subject_number
               }));
      
      },
      err => console.error(err),
      // () => console.log('done loading Trace Types')
    );
  };

}




interface ModifiedRecords {
  addedRecords: { [key: string]: Object }[];
  deletedRecords: { [key: string]: Object }[];
  changedRecords: { [key: string]: Object }[];
}